import { getLocalizeInjector } from '../common/localize-injector.js';

// This is a duplication
// of the LitTable localization IDs, which are used in the LitTable component.
// main file is in the global localization folder
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  public static readonly prefix = 'UI.webmodule-common.components.table.LitTable.';
  public static readonly paginator_first = `${Id.prefix}paginator.first`;
  public static readonly paginator_prev = `${Id.prefix}paginator.prev`;
  public static readonly paginator_next = `${Id.prefix}paginator.next`;
  public static readonly paginator_last = `${Id.prefix}paginator.last`;
  public static readonly paginator_loading = `${Id.prefix}paginator.loading`;
  public static readonly column1 = `${Id.prefix}column1`;
  public static readonly column2 = `${Id.prefix}column2`;
}

/*

This is an internal wrapper to the external localized code.
 */

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangLitTable {
  public static paginatorFirst(): string {
    return getLocalizeInjector().interpolate(Id.paginator_first);
  }

  public static paginatorPrev(): string {
    return getLocalizeInjector().interpolate(Id.paginator_prev);
  }

  public static paginatorNext(): string {
    return getLocalizeInjector().interpolate(Id.paginator_next);
  }

  public static paginatorLast(): string {
    return getLocalizeInjector().interpolate(Id.paginator_last);
  }

  public static paginatorLoading(): string {
    return getLocalizeInjector().interpolate(Id.paginator_loading);
  }

  public static column1(): string {
    return getLocalizeInjector().interpolate(Id.column1);
  }

  public static column2(): string {
    return getLocalizeInjector().interpolate(Id.column2);
  }
}
